import React from 'react'
import styled from 'styled-components'
import IrregularInteraction from '../IrregularInteraction'
import ItemImageAnimated from '../ItemImageAnimated'
import Frame1Image from '../../assets/images/item--ac--f1@3x.png'
import Frame2Image from '../../assets/images/item--ac--f2@3x.png'
import Frame3Image from '../../assets/images/item--ac--f3@3x.png'
import Frame4Image from '../../assets/images/item--ac--f4@3x.png'
import Frame5Image from '../../assets/images/item--ac--f5@3x.png'
import Frame6Image from '../../assets/images/item--ac--f6@3x.png'
import Frame7Image from '../../assets/images/item--ac--f7@3x.png'
import Frame8Image from '../../assets/images/item--ac--f8@3x.png'
import Frame9Image from '../../assets/images/item--ac--f9@3x.png'

const path =
  'M84.34,0 L85.56,0.88 L85.56,79.34 L1.22,128.03 L0,127.15 L0,48.69 L84.34,0 Z'

const frames = [
  Frame1Image,
  Frame2Image,
  Frame3Image,
  Frame4Image,
  Frame5Image,
  Frame6Image,
  Frame7Image,
  Frame8Image,
  Frame9Image,
]

const AC = ({ animate, ...props }) => (
  <IrregularInteraction
    path={path}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 168 157"
    sparksTop={46}
    sparksLeft={47}
    {...props}
  >
    <ItemImageAnimated srcs={frames} fps={6} animate={animate} />
  </IrregularInteraction>
)

AC.propTypes = IrregularInteraction.propTypes

export default AC



// WEBPACK FOOTER //
// ./src/components/items/AC.js